/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Partial<FolderPermission>, schemaOptions: { partial: true })
 */
export interface FolderPermissionPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    /**
     * Nivel de permiso para la carpeta
     */
    permissionLevel?: FolderPermissionPartial.PermissionLevelEnum;
    folderId?: string;
    userId?: number;
    companyId?: string;
}
export namespace FolderPermissionPartial {
    export type PermissionLevelEnum = 'viewer' | 'editor' | 'manager' | 'admin';
    export const PermissionLevelEnum = {
        Viewer: 'viewer' as PermissionLevelEnum,
        Editor: 'editor' as PermissionLevelEnum,
        Manager: 'manager' as PermissionLevelEnum,
        Admin: 'admin' as PermissionLevelEnum
    };
}


